/**
 * @fileoverview WelcomePage - Standalone landing page
 *
 * Layout reference: tripeaks-solitaire/index.html
 */

import './WelcomePage.css'

interface WelcomePageProps {
  onStartSignup: () => void
  onLogin: () => void
}

export default function WelcomePage({ onStartSignup, onLogin }: WelcomePageProps) {
  return (
    <div className="welcome-page">
      <div className="page-header">
        <div className="container">
          <div className="app-logo-wrapper">
            <div className="app-logo" role="img" aria-label="JumpJumpJump logo" />
            <p className="app-name">Jump Jump Jump</p>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <button type="button" className="btn-start" onClick={onStartSignup}>
            Start Game
          </button>
          <p className="help-login">
            Already have an account?{' '}
            <button type="button" className="link-login" onClick={onLogin}>
              Login
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}
